import type { Lang } from './translations';
import { pagesAr, type PageTranslations } from './pages';
import { pagesEn } from './pages-en';

export const pages: Record<Lang, PageTranslations> = { ar: pagesAr, en: pagesEn };
export type { PageTranslations };
